import React, { useRef, useState } from 'react';
import { Loader2Icon, MousePointer2Icon } from 'lucide-react';
import { ProtectPanel } from '../../panels/protect/ProtectPanel';
import { CutoutFrame } from '../CutoutFrame';
import { useProtectDemo } from '../../../hooks/useProtectDemo';
import { useViewportModelReady } from '../../../hooks/useViewportModelReady';
import type { ProtectAiResult, ProtectSettings } from '../../../types/protect';

/** Live Protect panel driving a paintable copy of the project's model. */
export function ProtectDemo() {
  const ready = useViewportModelReady();
  const viewRef = useRef<HTMLDivElement>(null);
  const [settings, setSettings] = useState<ProtectSettings>({
    tool: 'paint',
    brushSize: 5,
    mode: 'protected'
  });
  const [aiResult, setAiResult] = useState<ProtectAiResult | null>(null);
  const {
    painterRef,
    loaded
  } = useProtectDemo(viewRef, settings, ready);
  const runAi = () => {
    const p = painterRef.current;
    if (!p) return;
    void p.aiSelect(() => false).then(regions => setAiResult({
      id: Date.now(),
      regions
    }));
  };
  return <CutoutFrame label="Protect panel with a paintable model" className="pointer-events-auto flex h-[430px]" data-id="element-1010" data-mp="1qni7w3xeulot">
      <div className="flex shrink-0 p-[8px] [&>section]:max-h-full" data-id="element-1011" data-mp="20fe3n8c0xzpv">
        <ProtectPanel settings={settings} onSettingsChange={setSettings} onClose={() => undefined} onDone={() => painterRef.current?.save()} onDeselectAll={() => painterRef.current?.clearAll()} onRunAi={runAi} aiResult={aiResult} data-id="element-1012" data-mp="20hqu69vuliej" />
        
      </div>
      <div className="relative min-w-0 flex-1" data-id="element-1013" data-mp="2jei8e4wj97bq">
        <div ref={viewRef} className="absolute inset-0" data-id="element-1014" data-mp="2jd78wha4elqf" />
        {!loaded && <div className="absolute inset-0 flex items-center justify-center gap-2 text-[12px] text-pf-muted" data-id="element-1015" data-mp="2ef5q7xglwofh">
            <Loader2Icon className="h-[14px] w-[14px] animate-spin" data-id="element-1016" data-mp="p1inpxdapmxl" /> Waiting for the model to load…
          </div>}
        {loaded && <span className="pointer-events-none absolute bottom-[8px] left-1/2 flex -translate-x-1/2 items-center gap-[5px] whitespace-nowrap rounded-full bg-white/90 px-[9px] py-[3px] text-[11px] font-semibold text-pf-ink shadow-sm" data-id="element-1017" data-mp="k3qxr8w7oaw1">
            <MousePointer2Icon className="h-[11px] w-[11px] text-pf-blue" strokeWidth={2.4} data-id="element-1018" data-mp="1iposzbnzh0xq" /> Drag on the model to paint · drag off it to rotate
          </span>}
      </div>
    </CutoutFrame>;
}